import {
  BaseCardEntity,
  BaseCustomerPaymentMethodsEntity,
} from 'libs/shared/models/customer-payment-methods/customer-payment-methods.models'

export interface CustomerPaymentMethodsEntity extends BaseCustomerPaymentMethodsEntity {}

export interface CardEntity extends BaseCardEntity {}

export interface CustomerPaymentMethodsResponse {
  user: string
  stripe_connect: string
  stripe_customer_id: string
  payment_methods: CustomerPaymentMethodsEntity[]
}

export const CUSTOMER_PAYMENT_METHODS_LOADER = {
  loadCustomerPaymentMethods: {
    id: 'loadCustomerPaymentMethods',
  },
}
